import { motion } from "framer-motion";
import { Instagram, Music2 } from "lucide-react";

const SAWYER_IMG = "/images/sawyer-2.webp";

export const MeetSawyer = () => (
  <section data-testid="host-section" className="bg-white">
    <div className="max-w-6xl mx-auto px-6 py-24 grid lg:grid-cols-12 gap-12 items-center">
      <motion.div
        className="lg:col-span-7"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
      >
        <p className="font-accent text-2xl text-clay mb-3">your host</p>
        <h2 data-testid="host-title" className="font-heading text-4xl sm:text-5xl tracking-tight text-ink">
          Hey — I'm Sawyer.
        </h2>
        <div className="mt-6 space-y-4 text-base sm:text-lg text-stone-text leading-relaxed max-w-xl">
          <p>
            I started creating fitness content while still working my 9–5, with no idea just how much that decision would change my life.
          </p>
          <p>
            One of my first videos blew up. My TikTok grew to hundreds of thousands, my Instagram followed, and suddenly the thing I had dreamed about — becoming a full-time creator — was actually becoming my life. That personal brand went on to open doors to brand deals, businesses, travel + a career that gave me the freedom I had always wanted.
          </p>
          <p>
            Today, I've grown my Instagram to 200K+ and TikTok to 300K+. But the most valuable thing I built wasn't any one business. <span className="font-semibold text-ink">It was my personal brand.</span>
          </p>
          <p>
            And now I want to help other Christian women in fitness + wellness understand how powerful building theirs can be — around their strengths, their story, their faith and what they feel God is calling them to share.
          </p>
        </div>
        <div className="mt-8 flex flex-wrap gap-4">
          <div data-testid="host-stat-instagram" className="inline-flex items-center gap-2 rounded-full border border-line bg-cream px-5 py-2.5">
            <Instagram className="h-4 w-4 text-clay" />
            <span className="text-sm font-semibold text-ink">200K+ on Instagram</span>
          </div>
          <div data-testid="host-stat-tiktok" className="inline-flex items-center gap-2 rounded-full border border-line bg-cream px-5 py-2.5">
            <Music2 className="h-4 w-4 text-clay" />
            <span className="text-sm font-semibold text-ink">300K+ on TikTok</span>
          </div>
        </div>
      </motion.div>
      <motion.div
        className="lg:col-span-5"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.15 }}
      >
        <img
          data-testid="host-image"
          src={SAWYER_IMG}
          alt="Sawyer Fast, your webinar host"
          className="rounded-2xl object-cover aspect-[4/5] w-full shadow-[0_20px_40px_rgb(0,0,0,0.08)]"
        />
      </motion.div>
    </div>
  </section>
);
